module.exports = __webpack_public_path__ + "assets/img/btn_light.43669417.png";